// extracted by mini-css-extract-plugin
module.exports = {"container":"DrawerImage_container__gvfCj","divider":"DrawerImage_divider__Cqh2h"};